function remove(a) {
    $('.loader').css('display', 'block');
    
    $('.cart__scrollable').addClass('loader-back');
    
    setTimeout(function () {   
        $(this).val('Submit');
        
        $('.prearrz').css('display', 'none');
        
        var arr = $('.prearrz');
        
        for (var i = 0; i < arr.length; i++) {
            $('.afterpz').append(arr[i]);
        }
        
        $('.prearrz').css('display', 'block');
        
        $('.sarrz').css('display', 'none');
        
        var arr = $('.sarrz');
        
        for (var i = 0; i < arr.length; i++) {
            
            $('.aftersz').append(arr[i]);
            
        }
        
        // $('.sarrz').css('display', 'block');

        // if($('.sarrz').length - $('[data-la-only="true"]').length > 0){
        //     $('.sarrz').css('display','block');
        //   }
    
        //   $('.la-only').css('display', 'none');
    
        //   $('[data-la-only="true"]').each(function() {
        //     $('.la-only').append(this);
        //   });
    
        //   if($('[data-la-only="true"]').length > 0) {
        //     $('.la-only').css('display', 'block');
        //   }

        if($('.sarrz:not([data-is-pre="true"])').length - $('[data-la-only="true"]').length > 0){
            $('.sarrz').css('display','block');
            $('.aftersz').css('display','block');
          }
          $('[data-la-only="true"]').each(function() {
            $('.la-only').append(this);
          });
      
          if($('[data-la-only="true"]').length > 0) {
            $('.la-only').css('display', 'block');
          }
          
          $('.sarrz').css('display','block');

          // $('.cart__item .js-qty__adjust').click(function(){
          //   var $val = $(this).siblings('.js-qty__num').first();
        
          //   var valu = $val.attr('max');
        
          //   var $parentProductMQ = $(this).parents('[data-mq]');
        
          //   if(!valu && $parentProductMQ){
          //     valu = $parentProductMQ.data('mq');
          //   }
        
          //   var vv = $val.val();
        
          //   if(vv >= valu){
          //     $val.val(valu);
          //     $val.next().next().next().prop('disabled', true);
          //   }
        
          //   else if(vv > valu){
          //     $val.attr('value', valu);
          //   }
        
          //   else if(vv < valu){
          //     $val.next().next().next().prop('disabled', false);
          //   }
          // });
        
    }, 1900);
    
    var vid = $(a).attr('data-id');
    
    vid = parseInt(vid);

    $.ajax({
        async: false,
        type: "POST",
        url: "/cart/change.js",
        data: {
            'quantity': 0,
            'id': vid
        },
        dataType: 'json',
        success: function () {
            document.dispatchEvent(new CustomEvent('cart:build'));
        }
    })
    setTimeout(function () {
        $('.loader').css('display', 'none');
        $('.cart__scrollable').removeClass('loader-back');

    }, 2000);

    updateShippingThresholdProgress();

    if($('.qtysel') && $('.add-to-cart')){
        $('.add-to-cart').removeAttr("disabled");
        $("#add-to-cart-text").text("Add to Cart");
        $("#btn--add-to-cart_fixed").text("Add to Cart");
        $('.qtysel').val(1);
    }
}

setInterval(function(){
    var page = $('.page_by').attr('value');
    var colco = $('.col_count').attr('value');
    page = parseInt(page);
    colco = parseInt(colco);
    if(page >= colco){
        $('button.js-load-more').prop('disabled', true);
        $('button.js-load-more').addClass('hide');
    }
   // else{
    //    $('button.js-load-more').prop('disabled', false);
    //    $('button.js-load-more').removeClass('hide');
    //}
},300)
